import deleteFilter from '../../rest/delete-filter/index.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (filterId: string): Promise<void> => deleteFilter(filterId);
